module.exports = __webpack_public_path__ + "img/Baumschmuck.6c3eda22.svg";